import { useStore } from 'effector-react';
import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { routes } from 'src/routes';
import { user$ } from 'src/store/user.store';
import { HomePage } from './home.page';

export const HomeRouter = () => {
	const user = useStore(user$);

	return (
		<Switch>
			<Route path={routes.root.home.path}>
				{user != null && <HomePage/>}
			</Route>
		</Switch>
	);
};
